require("./application");

import logger from "../logger";
import { page } from "../tracking";
import { formatPhoneNumber } from "../formatters";

const setFieldValue = (name, value) => {
  if (!value) return;

  document
    .querySelectorAll(`[data-param-from-parent="${name}"]`)
    .forEach(($el) => ($el.innerHTML = value));
  document.querySelectorAll(`input[name*="${name}"]`).forEach(($input) => {
    logger.info("Setting input value", { name: $input.name, value: $input.value });
    if ($input.value) return;

    $input.value = value;

    if (name === "phone") {
      formatPhoneNumber({ target: $input });
    }

    $input.dispatchEvent(new Event("valueSetFromParent"));
  });
  document.querySelectorAll(`select[name*="${name}"]`).forEach(($select) => {
    if ($select.value) return;

    const $option = $select.querySelector(`option[value="${value}"]`);
    if ($option) $option.selected = "selected";
  });
};

const autoSubmitForm = () => {
  const $form = document.querySelector('form[data-auto-submit="true"]');
  if (!$form) return false;

  $form.submit();
  return true;
};

const handlePageLoaded = (params, parentUrl, referrer) => {
  setFieldValue("parent_url", parentUrl);
  params.forEach((value, key) => setFieldValue(key, value));
  window.dispatchEvent(new Event("allValuesSetFromParent"));
  if (autoSubmitForm()) return;

  page(params, referrer);
};

// Set up observer to determine if frame is visible
let isFullFrameInView = false;
const observer = new IntersectionObserver(
  (event) => {
    isFullFrameInView = event[0].isIntersecting;
  },
  {
    root: null,
    rootMargin: "0px",
    threshold: 1,
  }
);
observer.observe(document.documentElement);

window.iFrameResizer = {
  onMessage: ({ type, value: { isInitialPageLoad, queryString, referrer, url: parentUrl } }) => {
    if (type === "pageLoaded") {
      const params = new URLSearchParams(queryString);
      logger.info("Page loaded message received", { params: params, parent_url: parentUrl });

      handlePageLoaded(params, parentUrl, referrer);
      if (isInitialPageLoad || isFullFrameInView) return;

      window.parentIFrame.scrollToOffset(0, 0);
    }
  },
};

require("iframe-resizer").contentWindow;
